// extracted by mini-css-extract-plugin
export default {"loader":"ImageLoader__loader--kEWFNk"};